import { render, staticRenderFns } from "./TaxInvoiceCode.vue?vue&type=template&id=258c9af1&"
import script from "./TaxInvoiceCode.vue?vue&type=script&lang=ts&"
export * from "./TaxInvoiceCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258c9af1')) {
      api.createRecord('258c9af1', component.options)
    } else {
      api.reload('258c9af1', component.options)
    }
    module.hot.accept("./TaxInvoiceCode.vue?vue&type=template&id=258c9af1&", function () {
      api.rerender('258c9af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/TaxInvoiceCode.vue"
export default component.exports